// Preserve the source, crop and colour settings. Only vary Unsplash delivery size.
export function responsiveImageProps(src: string, sizes: string, hero = false) {
  try {
    const original = new URL(src);
    if (original.hostname !== 'images.unsplash.com') return { src };
    const widths = hero ? [640, 960, 1440, 1920] : [400, 640, 960, 1440];
    const srcSet = widths.map((width) => {
      const url = new URL(original);
      url.searchParams.set('w', String(width));
      url.searchParams.set('auto', 'format');
      return url.href + ' ' + width + 'w';
    }).join(', ');
    return { src, srcSet, sizes };
  } catch {
    return { src };
  }
}
